import styled from "styled-components"

export const HeaderContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    width: 100%;
    padding: 16px 0;
`

export const BackButtonContainer = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    flex: 1;
    min-width: 0;

    &:hover {
        opacity: 0.7;
    }

    &:focus-visible {
        outline: 2px solid #503abd;
        outline-offset: 2px;
        border-radius: 4px;
    }

    i {
        font-size: 14px;
        color: #495057;
    }
`

export const BackButtonText = styled.span`
    font-family: "Roboto", sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    color: #495057;
    white-space: nowrap;
`

export const PageTitle = styled.h1`
    font-family: "Roboto", sans-serif;
    font-size: 20px;
    font-weight: 600;
    line-height: 1.3;
    color: #000000;
    margin: 0;
    white-space: nowrap;
    text-align: center;
    flex-shrink: 0;
`

export const Spacer = styled.div`
    flex: 1;
    min-width: 0;
`
